import { useMutation } from '@tanstack/react-query';
import { useSelectedCategory, useSetMetasiteError, useStoreName } from '../../../store/appStore';
import { useSpec } from '../../../hooks/useSpec';
import { DomainFlow } from '../../../experiments';
import { usePaymentAcceptance } from './usePaymentAcceptance';
import { useLoadDomainSuggestions } from '../../domain/api/mutations';
import {
  useUpdateSiteSettings,
  useUpdateComponent,
  usePublishSite,
  useConnectPaymentProvider,
} from '../api/mutations';
import { storeNameKeys } from '../api';

export function useStoreLaunch() {
  const storeName = useStoreName();
  const selectedCategory = useSelectedCategory();
  const { isPaymentsAccepted } = usePaymentAcceptance();
  const setMetasiteError = useSetMetasiteError();
  const isDomainFlowEnabled = useSpec(DomainFlow);
  const updateSiteSettings = useUpdateSiteSettings();
  const updateComponent = useUpdateComponent();
  const publishSite = usePublishSite();
  const connectPayment = useConnectPaymentProvider();
  const loadDomainSuggestions = useLoadDomainSuggestions();

  const launchMutation = useMutation({
    mutationKey: storeNameKeys.mutations.launchStore(),
    mutationFn: async () => {
      if (storeName) {
        await updateSiteSettings.mutateAsync();

        //        if (!CATEGORIES_WITHOUT_COMPONENT_UPDATE.includes(selectedCategory)) {
        //          await updateComponent.mutateAsync();
        //        }

        if (isDomainFlowEnabled) {
          await loadDomainSuggestions.mutateAsync(storeName);
        }
      }

      await publishSite.mutateAsync();

      if (isPaymentsAccepted) {
        try {
          await connectPayment.mutateAsync();
        } catch (error) {
          console.error('Failed to connect payment provider:', error);
        }
      }

      return { success: true };
    },
    onError: (error) => {
      console.error('Failed to launch store:', error);
      setMetasiteError(true);
    },
  });

  return {
    launchStore: launchMutation.mutate,
    isPending: launchMutation.isPending,
    isSuccess: launchMutation.isSuccess,
    isError: launchMutation.isError,
  };
}
